<!-- src/components/forms/QuestionForm.vue -->
<template>
  <div class="space-y-8 max-w-3xl mx-auto px-4 sm:px-6">
    <div
      v-for="question in section.questions"
      :key="question.id"
      class="bg-base-100 border border-base-300 rounded-xl p-6 shadow-sm hover:shadow transition-shadow focus-within:ring-2 focus-within:ring-primary">
      <QuestionRenderer :question="question" v-model="formStore.answers[question.id]" />
    </div>

    <div class="flex items-center justify-between mt-8">
      <button v-if="formStore.currentSectionIndex > 0" class="btn btn-outline" @click="back">
        {{ t("ui.back") }}
      </button>

      <button class="btn btn-primary ml-auto" @click="next">
        {{ t("ui.next") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { useFormStore } from "@/features/blueprint/stores/useFormStore";
import QuestionRenderer from "./QuestionRenderer.vue";
import { useI18n } from "vue-i18n";

defineProps<{ section: any }>();
const formStore = useFormStore();
const { t } = useI18n();

function next() {
  formStore.completeCurrentSection();
}
function back() {
  formStore.prevSection();
}
</script>
